import { useLocation } from 'react-router-dom';
import { NewsDetailWrapper } from './styled.js'
import { newsActions } from "redux/slice/newsSlice"
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { newsSelector } from "redux/selector"
import Loading from 'components/Loading/index.js';
import { useMemo } from 'react';
import Directional from "components/Directional/index";
import { actionScrollToTop } from 'utils/index.js';

function NewsDetail() {

    const location = useLocation();
    const queryPath = location.pathname;
    const myArray = queryPath.split("/");
    const slug = myArray[myArray.length - 1];
    const dispatch = useDispatch()
    const newsState = useSelector(newsSelector)

    useEffect(() => {
        dispatch(newsActions.getNewsDetail({ slug }))
    }, [dispatch, slug])

    const paths = useMemo(() => {
        let path = []
        if (newsState.newsDetail.length > 0) {
            path = [
                {
                    name: newsState.newsDetail[0].name,
                    path: "/news-category/" + newsState.newsDetail[0].slug
                },
                {
                    name: newsState.newsDetail[0].news_title,
                    path: "/news/" + newsState.newsDetail[0].news_slug
                },
            ]
        }
        return path
    }, [newsState.newsDetail])


    useEffect(() => {
        actionScrollToTop()
    }, [])

    return (
        <NewsDetailWrapper>
            {
                newsState.isFetching && <Loading />
            }
            <div className="news-detail container-fluid">
                <div className='grid wide'>
                    {
                        paths.length > 0 &&
                        <div className='news-detail_pagination'>
                            <Directional paths={paths} />
                        </div>
                    }
                    {
                        !newsState.isFetching && newsState.newsDetail.length === 0 &&
                        <div className='news_content_empty'>
                            <p>Danh mục chưa có bài viết nào!</p>
                        </div>
                    }
                    <div className='news-detail_body'>
                        {
                            newsState.newsDetail.length > 0 &&
                            <h1 className='news-detail_body_title'>
                                {newsState.newsDetail[0].news_title}
                            </h1>
                        }
                        {
                            newsState.newsDetail.length > 0 &&
                            <p className='news-detail_body_author'>Đăng bởi{' '}
                                <strong>
                                    {newsState.newsDetail[0].account_name}
                                </strong> -  {newsState.newsDetail[0]?.updated_at?.slice(0, 10)}</p>
                        }
                        {
                            newsState.newsDetail.length > 0 &&
                            <div className='news-detail_body_content' dangerouslySetInnerHTML={{ __html: newsState.newsDetail[0].content }}>
                            </div>
                        }
                    </div>

                </div>
            </div>
        </NewsDetailWrapper>
    );
}

export default NewsDetail;
